import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SubPage } from "@/components/profile/SettingsKit";
import { Card } from "@/components/ui";
import { buildHead, SITE } from "@/lib/seo";

export const Route = createFileRoute("/_app/settings_/terms")({
  head: () =>
    buildHead({
      path: "/settings/terms",
      title: "Terms of service",
      description: `The terms that govern your use of ${SITE.name}.`,
    }),
  component: TermsPage,
});

// NOTE: placeholder terms copy — replace with your reviewed legal text.
// Section bodies live in the account catalog as terms.sections.<id>.{h,p}.
const SECTION_IDS = ["acceptance", "eligibility", "account", "trading", "acceptableUse", "disclaimers", "changes"] as const;

function TermsPage() {
  const { t } = useTranslation("account");
  return (
    <SubPage title={t("terms.title")} subtitle={t("terms.subtitle")}>
      <Card className="space-y-5 p-5">
        {SECTION_IDS.map((id) => (
          <section key={id}>
            <h2 className="mb-1 text-sm font-semibold text-fg">{t(`terms.sections.${id}.h`)}</h2>
            <p className="text-sm leading-relaxed text-fg-muted">{t(`terms.sections.${id}.p`)}</p>
          </section>
        ))}
      </Card>
    </SubPage>
  );
}
